/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useMemo } from 'react';
import { Link } from '@fluentui/react-components';
// @ts-ignore
import { ReactTemplate } from '@bingads-webui-react/react-template';
import { I18nModel } from '@bingads-webui/copilot-i18n';

interface IMSACopilotDisclaimerProps {
  i18n: I18nModel;
  isShortDisclaimer: boolean;
}

export const MSACopilotDisclaimer: React.FC<IMSACopilotDisclaimerProps> = React.memo((props) => {
  const { i18n, isShortDisclaimer = false } = props;

  const privacyStatementLink = useMemo(() => {
    const link = `https://privacy.microsoft.com/${i18n.getLocale() || 'en-us'}/privacystatement`;
    return (
      <Link
        className="disclaimer-link privacy-statement"
        href={link}
        target="_blank"
        style={{ color: '#106EBE' }}
      >
        { isShortDisclaimer ? i18n.getString(_TL_('Privacy')) : i18n.getString(_TL_('Microsoft Privacy Statement'))}
      </Link>
    );
  }, [i18n]);

  const contentTemp = useMemo(() => i18n.getString(_TL_('Copilot is powered by AI. Make sure to verify support content in our Help Center and check for mistakes. {{privacyStatementLink}}')), []);
  const shortDisclaimer = useMemo(() => i18n.getString(_TL_('Copilot uses AI. Check for mistakes. {{privacyStatementLink}}')), []);

  return (
    <ReactTemplate
      template={isShortDisclaimer ? shortDisclaimer : contentTemp}
      model={{
        privacyStatementLink,
      }}
    />
  );
});
